import { MODEL_PARTS } from '../../mockData';
import type { AircraftModelId, PartType } from '../../types';

// The parts that exist for a given model — drives the per-model config parts list.
export const getModelParts = (model: AircraftModelId): PartType[] => [...MODEL_PARTS[model]];
